// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.DefaultGaugePropsMappingProps.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
import { toJS } from 'mobx';
import { isEqual } from 'lodash/fp';
import { DEFAULT_SETTING_VALUE } from 'logic/data/Izenda.ReportPartGaugeConstants';
import { parser as chartDataParser } from 'share/utils/Izenda.ChartDataParser';

export default (reportPartDetails, fieldStore) => {
  const reportPartContent = reportPartDetails.reportPartContent || {};

  const getProperties = key => {
    if (!key) {
      const properties = reportPartDetails && reportPartDetails.getReportPartProperties();
      const props = toJS(properties);
      return props;
    }

    return reportPartContent.getReportPartProperties(key);
  };

  return {
    getAllChartProps() {
      const gaugeProperties = getProperties();
      return {
        chartOptions: {
          ...gaugeProperties,
          colors: reportPartDetails.getThemeColors(gaugeProperties)
        },
        seriesOptions: reportPartDetails.fieldCollection,
        chartData: chartDataParser(reportPartContent.activeElmsByContainers, reportPartDetails.expandedLevel, {
          fieldsMapping: reportPartDetails.previewDataFieldsMapping,
          records: reportPartDetails.previewDataRecords,
          rawData: reportPartDetails.previewData
        })
      };
    },

    getSettingBorder() {
      return {
        'izEntire.borderColor': getProperties('izEntire.borderColor'),
        'izEntire.borderWidth': getProperties('izEntire.borderWidth'),
        'izEntire.borderStyle': getProperties('izEntire.borderStyle')
      };
    },

    hadSettingBorder() {
      const currentSetting = {
        'izEntire.borderColor': getProperties('izEntire.borderColor'),
        'izEntire.borderWidth': getProperties('izEntire.borderWidth'),
        'izEntire.borderStyle': getProperties('izEntire.borderStyle')
      };

      return !(
        isEqual(currentSetting, DEFAULT_SETTING_VALUE.borderDefault) ||
        isEqual(currentSetting, DEFAULT_SETTING_VALUE.borderNew)
      );
    },

    getSettingRefreshInterval() {
      return getProperties('dataRefreshInterval');
    },

    hadSettingRefreshInterval() {
      const tempProp = getProperties();
      const defaultSetting = DEFAULT_SETTING_VALUE.refreshIntervalDefault;
      const refreshSetting = getProperties('dataRefreshInterval');

      return (
        refreshSetting.value !== defaultSetting.value || refreshSetting.updateInterval !== defaultSetting.updateInterval
      );
    },

    getColorTheme() {
      const properties = getProperties() || {};
      return {
        colorPalette: properties.colorTheme,
        isDefaultTheme: properties.isDefaultTheme
      };
    },

    fnResetBorderDefaultValue: reportPartContent.resetBorderDefaultValue.bind(reportPartContent),
    fnResetRefreshIntervalDefaultValue: reportPartContent.resetRefreshIntervalValue.bind(reportPartContent)
  };
};



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartGauge/Izenda.DefaultGaugePropsMappingProps.js